import { useEffect, useState } from 'react';
import type React from 'react';
import type { AnalysisTabs } from '../types/common.types';
import { useTour } from '@reactour/tour';

export const useAnalysisState = () => {
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [toggle, setToggle] = useState<AnalysisTabs>('preview');
  const [hideDetectionCanvas, setHideDetectionCanvas] = useState(false);
  const [renderFontsPannel, setRenderFontsPannel] =
    useState<React.ReactNode>(null);
  const [hoverDetection, setHoverDetection] = useState<string | undefined>();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);

  const [isPointerInSidebar, setIsPointerInSidebar] = useState(false);

  const [selected2DDocId, setSelected2DDocId] = useState<string>();
  const [selectedMrzId, setSelectedMrzId] = useState<string>();

  const handlePageChange = (newPageIndex: number) => {
    setPageIndex(newPageIndex);
  };

  const handleToggleChange = (
    newToggle: AnalysisTabs,
    options?: { mrz?: string; ddoc?: string }
  ) => {
    setToggle(newToggle);
    if (options?.mrz) {
      setSelectedMrzId(options.mrz);
    } else {
      setSelectedMrzId(undefined);
    }
    if (options?.ddoc) {
      setSelected2DDocId(options.ddoc);
    } else {
      setSelected2DDocId(undefined);
    }
    setHoverDetection(undefined);
  };

  const handleSelected2DDocIdChange = (id: string) => {
    setSelected2DDocId(id);
  };

  const handleSelectedMrzIdChange = (id: string) => {
    setSelectedMrzId(id);
  };

  const handlePopupToggle = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleNotesModalToggle = () => {
    setIsNotesModalOpen(!isNotesModalOpen);
  };

  // Tour logic
  const { isOpen, setCurrentStep, currentStep } = useTour();
  useEffect(() => {
    if (isOpen) {
      setHideDetectionCanvas(true);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      if (!hideDetectionCanvas && currentStep === 0) {
        setCurrentStep(1);
      }

      if (pageIndex === 1 && currentStep === 3) {
        setTimeout(() => {
          setCurrentStep(4);
        }, 1000);
      }
    }
  }, [isOpen, hideDetectionCanvas, pageIndex, setCurrentStep, currentStep]);

  return {
    // State
    pageIndex,
    setPageIndex,
    toggle,
    hideDetectionCanvas,
    setHideDetectionCanvas,
    renderFontsPannel,
    setRenderFontsPannel,
    hoverDetection,
    setHoverDetection,
    isPopupOpen,
    setIsPopupOpen,
    isNotesModalOpen,
    setIsNotesModalOpen,
    isPointerInSidebar,
    setIsPointerInSidebar,
    selected2DDocId,
    selectedMrzId,

    // Handlers
    handlePageChange,
    handleToggleChange,
    handlePopupToggle,
    handleSelected2DDocIdChange,
    handleSelectedMrzIdChange,
    handleNotesModalToggle,
  };
};
